(function () {

  var FA_SRC = 'https://kit.fontawesome.com/9e433f795f.js';
  var loading = false;
  var loaded = false;

  function loadFontAwesome() {
    if (loaded || loading) return;

    loading = true;

    var s = document.createElement('script');
    s.src = FA_SRC;
    s.async = true;
    s.crossOrigin = 'anonymous';

    s.onload = function () {
      loaded = true;
    };

    s.onerror = function () {
      loading = false;
    };

    document.head.appendChild(s);
  }

  function observe() {
    var sections = document.querySelectorAll('[data-require-fontawesome="true"]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      loadFontAwesome();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        loadFontAwesome();
        observer.disconnect();
      });
    }, {
      rootMargin: '200px'
    });

    sections.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

})();